import { _ } from 'vue-underscore';
import axios from '../../axios';
import Bus from '../../events/bus.js';

// temp
const apiStage = 'https://stage.thethinkingtraveller.com';
const apiEndpoint = process.env.VUE_APP_API;

export default {
  namespaced: true,
  state: {
    resultsContentTop: 0,
    allApiProperties: [],
    originalProperties: [],
    allproperties: [],
    filteredamenities: [],
    availableProperties: [],
    availablePropertiesAll: [],
    bookedProperties: [],
    mapResults: [],
    highlight: '',
    mapVisibleResults: [],
    updateResultsFromMap: true,
    updateMapFromResults: false,
    showAirports: false,
    sortBy: 'default',
    resultPages: [],
    statePayload: {},
    allDestinationCountries: null,
    allDestinations: [],
    destinations: [],
    subDestinations: [],
    selectedPeople: 0,
    selectedBedrooms: 0,
    thinkExquisite: false,
    flexibleDates: false,
    price: [1, 100],
    pricerangemin: 1,
    pricerangemax: 100,
    priceFilterActive: false,
    showBooked: false,
    collectionID: 0,
    pageType: 'normal',
    timesRendered: 0,
    isFilterActive: false,
    activeFilters: 0,
    listFilters: 0,
    collectionFilters: [],
    collectionFromDate: null,
    collectionToDate: null,
    currentPageId: 0,
    resultsCardClicked: 0,
    // regionsAll: {
    //   id: 999,
    //   name: 'All',
    //   description: 'All',
    //   selected: false,
    //   open: false,
    //   subRegions: [],
    // },
    // subregionsAll: {
    //   id: 999,
    //   name: 'All',
    //   description: 'All',
    //   selected: false,
    // },
    REGION_IDS: {
      PAXOS: 27,
      ANTIPAXOS: 14,
    },
    maxAllowableBeds: null,
  },
  getters: {
    getAllApiProperties: (state) => state.allApiProperties,
    getIsCollectionFilterActive: (state) => state.isFilterActive,
    getStatePayload: (state) => state.statePayload,
    getOriginalProperties: (state) => state.originalProperties,
    getResultPages: (state) => state.resultPages,
    getSortBy: (state) => state.sortBy,
    getShowAirports: (state) => state.showAirports,
    getMapVisibleResults: (state) => state.mapVisibleResults,
    getUpdateResultsFromMap: (state) => state.updateResultsFromMap,
    getUpdateMapFromResults: (state) => state.updateMapFromResults,
    getAllproperties: (state) => state.allproperties,
    getAvailableProperties: (state) => state.availableProperties,
    getAvailablePropertiesAll: (state) => state.availablePropertiesAll,
    getBookedProperties: (state) => state.bookedProperties,
    getMapProperties: (state) => state.mapResults,
    // getFilteredamenities: (state) => state.filteredamenities,
    getHiglightCard: (state) => state.highlight,
    getShowBooked: (state) => state.showBooked,
    getCollectionID: (state) => state.collectionID,
    getPageType: (state) => state.pageType,
    getResultsContentTop: (state) => state.resultsContentTop,
    getAllDestinations: (state) => state.allDestinations,
    getRegionIDs: (state) => state.REGION_IDS,
    // FILTERS
    getAllDestinationCountries: (state) => state.allDestinationCountries,
    getDestinations: (state) => state.destinations,
    getSubDestinations: (state) => state.subDestinations,
    getPeople: (state) => state.selectedPeople,
    getBedrooms: (state) => state.selectedBedrooms,
    getThinkExquisite: (state) => state.thinkExquisite,
    getFlexibleDates: (state) => state.flexibleDates,
    getPriceRange: (state) => state.price,
    getPriceRangeMin: (state) => state.pricerangemin,
    getPriceRangeMax: (state) => state.pricerangemax,
    isPriceFilterActive: (state) => state.priceFilterActive,
    getCurrentPage: (state) => state.currentPageId,
    getResultsCardClicked: (state) => state.resultsCardClicked,
    maxAllowableBeds: (state) => state.maxAllowableBeds,
  },
  mutations: {
    setAllApiProperties: (state, payload) => {
      state.allApiProperties = payload;
    },
    setIsCollectionFilterActive: (state, active) => {
      state.isFilterActive = active;
    },
    setStatePayload: (state, payload) => {
      state.statePayload = payload;
    },
    setOriginalProperties: (state, payload) => {
      state.originalProperties = payload;
    },
    setResultPages: (state, payload) => {
      state.resultPages = payload;
    },
    setSortBy: (state, sortvalue) => {
      state.sortBy = sortvalue;
    },
    setShowAirports: (state, visibility) => {
      state.showAirports = visibility;
    },
    setMapVisibleResults: (state, payload) => {
      state.mapVisibleResults = payload;
    },
    setUpdateResultsFromMap: (state, payload) => {
      state.updateResultsFromMap = payload;
    },
    setUpdateMapFromResults: (state, payload) => {
      state.updateMapFromResults = payload;
    },
    setAllproperties(state, payload) {
      state.allproperties = payload;
    },
    setFilteredamenities(state, payload) {
      state.filteredamenities = payload;
    },
    // updated by the map
    setAvailableProperties(state, payload) {
      state.availableProperties = payload;
    },
    // always controlled by the state
    setAvailablePropertiesAll(state, payload) {
      state.availablePropertiesAll = payload;
    },
    setBookedProperties(state, payload) {
      state.bookedProperties = payload;
    },
    setMapProperties(state, payload) {
      state.mapResults = payload;
    },
    setHiglightCard(state, cardId) {
      state.highlight = cardId;
    },
    setShowBooked(state, show) {
      state.showBooked = show;
    },
    setCollectionID(state, id) {
      state.collectionID = id;
    },
    setPageType(state, page) {
      state.pageType = page;
    },
    setResultsContentTop(state, payload) {
      state.resultsContentTop = payload;
    },
    setAllDestinations(state, payload) {
      state.allDestinations = payload;
    },
    setAllDestinationCountries(state, payload) {
      state.allDestinationCountries = payload;
    },
    // FILTERS
    setDestinations(state, payload) {
      state.destinations = payload;
    },
    setSubDestinations(state, payload) {
      state.subDestinations = payload;
    },
    setPeople(state, people) {
      state.selectedPeople = people;
    },
    setBedrooms(state, bedrooms) {
      state.selectedBedrooms = bedrooms;
    },
    setMaxAllowableBeds(state, maxAllowableBeds) {
      state.maxAllowableBeds = maxAllowableBeds;
    },
    setThinkExquisite(state, show) {
      state.thinkExquisite = show;
    },
    setFlexibleDates(state, flex) {
      state.flexibleDates = flex;
    },
    setPriceRange(state, payload) {
      state.price = payload;
    },
    setPriceRangeMin(state, min) {
      state.pricerangemin = min;
    },
    setPriceRangeMax(state, max) {
      state.pricerangemax = max;
    },
    setPriceFilterActive(state, payload) {
      state.priceFilterActive = payload;
    },
    setCurrentPage(state, payload) {
      state.currentPageId = payload;
    },
    setResultsCardClicked(state, payload) {
      state.resultsCardClicked = payload;
    },
  },
  actions: {
    setSortingOnLoad({ commit, state, rootGetters }) {
      let sortBy;
      if (window.$cookies.get('sortResults')) {
        sortBy = window.$cookies.get('sortResults').value;
      } else {
        const countryCode = rootGetters['common/getOfficeStatus'].countryCode;
        sortBy = ['gb', 'GB'].includes(countryCode) ? 'default' : 'default';
      }
      commit('setSortBy', sortBy);
    },
    setupDestinations({ commit, state, rootGetters }) {
      const allRegions = rootGetters['regions/allRegions'];
      if (allRegions) {
        state.allDestinations = allRegions?.map((item) => ({ ...item, selected: false, open: false }));
        state.allDestinations.forEach((des) => {
          des.subRegions = des.subRegions.filter((x) => x.liveVillaCount > 0).map((item) => ({ ...item, selected: false }));
        });
      }
    },
    setupDestinationCountries({ commit, state, rootGetters }) {
      const regions = [];
      rootGetters['countries/allCountries'].filter((c) => c.regions && c.regions.length > 0).forEach((cr, key) => {
        regions.push(...cr.regions);
      });
      regions.filter((v, i, a) => a.findIndex((t) => (t.id === v.id)) === i);
      const regionCountries = [];
      const distinctCountries = Object.values(regions.reduce((o, a) => { o[a.countryId] = a; return o; }, {}));
      distinctCountries.forEach((region) => {
        const country = rootGetters['countries/allCountries'].filter((x) => x.id == region.countryId)[0];
        if (country && country.id > 0) {
          regionCountries.push(country);
        }
      });
      const countries = regionCountries.map((item) => ({ ...item, selected: false, open: false }));
      const order = ['Italy', 'Greece', 'France'];
      state.allDestinationCountries = countries.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
    },

    clearDestinations({ commit, state }) {
      commit('setDestinations', []);
      commit('setSubDestinations', []);
      window.$cookies.set('destinations', '');
      window.$cookies.set('subdestinations', '');
      state.allDestinations.forEach((x) => {
        x.selected = false;
        x.open = false;
        x.subRegions.forEach((s) => s.selected = false);
      });
    },

    async fetchAllAvailableProperties({ commit, state, rootGetters }) {
      let allProps = rootGetters['properties/getAllproperties'];

      // if browser in Italy then only include villas where HideForItaly is FALSE
      if (['it', 'ita'].includes(rootGetters['common/getOfficeStatus'].countryCode)) {
        allProps = allProps.filter((p) => p.hideforitaly === false);
      }
      else if (['gr'].includes(rootGetters['common/getOfficeStatus'].countryCode)) {
        allProps = allProps.filter((p) => p.hideforgreece === false);
      }

      const availableProperties = allProps.filter((p) => p.booked === false);
      const bookedProperties = allProps.filter((p) => p.booked === true);
      const allProperties = [...availableProperties, ...bookedProperties];

      if ((state.showBooked)) {
        commit('setAllApiProperties', allProperties);
      }
      else {
        commit('setAllApiProperties', availableProperties);
      }
    },

    async fetchProperties({
      commit, dispatch, getters, state, rootGetters,
    }, payload) {
      // state.timesRendered++;

      // console.log('******fetchProperties*******')
      // console.log(' state.pageType ',  state.pageType)
      // console.log(' state.timesRendered ',  state.timesRendered)
      const allRegions = rootGetters['regions/allRegions'];
      const templateId = rootGetters['pages/currentPage'].templateId;
      const resultsPagePath = `${rootGetters['applinks/getLink']('page', 16).url}`;
      const currentPath = window.$router.app._route.path;
      // let currentlist = rootGetters['lists/getCurrentList'];
      const currentlist = rootGetters['pages/getCollectionData'];
      let listid = currentlist ? currentlist.listId : null;
      let listType = currentlist ? currentlist.listType : null;
      let hasHiddenPresetFilters = false;

      // console.log('>>>>>COLLECTION currentlist', currentlist)
      // console.log('COLLECTION ID =', listid)
      // console.log('COLLECTION listType', listType)
      // console.log('>>>OLD SET state.collectionID', state.collectionID)
      // console.log('>>>URL currentPath', currentPath)

      // COLLECTION - ON FIRST LOAD
      if (!!currentlist && currentlist.listId != state.collectionID) {
        commit('setDestinations', []);
        commit('setSubDestinations', []);
        commit('setThinkExquisite', false);
        dispatch('clearDestinations');
      }

      let {
        amenities,
        from,
        to,
        rooms,
        people,
        minprice,
        maxprice,
      } = payload.query;

      if (listType == 3) {
        let {
          filter_Amenities,
          filter_RegionIds,
          filter_SubRegionIds,
          filter_ArrivalDate,
          filter_Duration,
          filter_People,
          filter_BedsMin,
          filter_BedsMax,
          filter_PriceFrom,
          filter_PriceTo,
          dateInFilter,
          dateOutFilter,
        } = currentlist;

        // console.log('LIST TYPE 3 - CHECK WHICH FILTERS WE NEED TO USE')
        // console.log('LIST TYPE 3 - FILTER BY? filter_Amenities', filter_Amenities )
        // console.log('LIST TYPE 3 - FILTER BY? filter_RegionIds', filter_RegionIds )
        // console.log('LIST TYPE 3 - FILTER BY? filter_SubRegionIds', filter_SubRegionIds )
        // console.log('LIST TYPE 3 - FILTER BY? filter_ArrivalDate', filter_ArrivalDate )
        // console.log('LIST TYPE 3 - FILTER BY? filter_Duration', filter_Duration )
        // console.log('LIST TYPE 3 - FILTER BY? filter_BedsMin', filter_BedsMin )
        // console.log('LIST TYPE 3 - FILTER BY? filter_BedsMax', filter_BedsMax )
        // console.log('LIST TYPE 3 - FILTER BY? filter_People', filter_People )
        // console.log('LIST TYPE 3 - FILTER BY? filter_PriceFrom', filter_PriceFrom )
        // console.log('LIST TYPE 3 - FILTER BY? filter_PriceTo', filter_PriceTo )
        // console.log('LIST TYPE 3 - FILTER BY? dateInFilter', dateInFilter )
        // console.log('LIST TYPE 3 - FILTER BY? dateOutFilter', dateOutFilter )

        // -------first check if data returned is valid to filter --------//

        // FOR TESTING
        // filter_RegionIds = '1,5'
        // filter_SubRegionIds = '25,27,18,19'

        // refactor again once format in backend changes
        filter_RegionIds = Number(filter_RegionIds) > 0 || filter_RegionIds.length > 1
          ? filter_RegionIds.length > 1
            ? filter_RegionIds.split(',').map((x) => Number(x)).sort((a, b) => a - b)
            : Array.of(filter_RegionIds).map((x) => Number(x))
          : null;

        // if no preset region but des query is passed then set the region filter.
        if (!filter_RegionIds && payload && payload.query && payload.query.des) {
          filter_RegionIds = payload.query.des.split(',').map((x) => Number(x)).sort((a, b) => a - b);
        }

        filter_SubRegionIds = Number(filter_SubRegionIds) > 0 || filter_SubRegionIds.length > 1
          ? filter_SubRegionIds.length > 1
            ? filter_SubRegionIds.split(',').map((x) => Number(x)).sort((a, b) => a - b)
            : Array.of(filter_SubRegionIds).map((x) => Number(x)).sort((a, b) => a - b)
          : null;

        filter_Amenities = filter_Amenities || null;
        filter_ArrivalDate = filter_ArrivalDate == '0001-01-01T00:00:00' ? null : filter_ArrivalDate;
        filter_Duration = Number(filter_Duration) > 0 ? Number(filter_Duration) : 0;
        filter_People = Number(filter_People) > 0 ? filter_People : null;
        filter_BedsMin = Number(filter_BedsMin) > 0 ? filter_BedsMin : null;
        filter_BedsMax = Number(filter_BedsMax) > 0 ? filter_BedsMax : null;
        filter_PriceFrom = Number(filter_PriceFrom) > 1000 ? filter_PriceFrom : null;
        filter_PriceTo = Number(filter_PriceTo) < 50000 ? filter_PriceTo : null;
        dateInFilter = dateInFilter == '0001-01-01T00:00:00' ? null : dateInFilter;
        dateOutFilter = dateOutFilter == '0001-01-01T00:00:00' ? null : dateOutFilter;
        hasHiddenPresetFilters = !!dateInFilter || !!dateOutFilter || !!filter_BedsMax;

        // console.log('check if filter exists filter_Amenities', filter_Amenities )
        // console.log('check if filter exists filter_RegionIds', filter_RegionIds )
        // console.log('check if filter exists filter_SubRegionIds', filter_SubRegionIds )
        // console.log('check if filter exists filter_ArrivalDate', filter_ArrivalDate )
        // console.log('check if filter exists filter_People', filter_People )
        // console.log('check if filter exists filter_BedsMin', filter_BedsMin )
        // console.log('check if filter exists filter_BedsMax', filter_BedsMax )
        // console.log('check if filter exists filter_PriceFrom', filter_PriceFrom )
        // console.log('check if filter exists filter_PriceTo', filter_PriceTo )
        // console.log('check if filter exists dateInFilter', dateInFilter )
        // console.log('check if filter exists dateOutFilter', dateOutFilter )
        // console.log('check if hasHiddenPresetFilters', hasHiddenPresetFilters )

        // COLLECTION TYPE 3 - ON FIRST LOAD
        if (listType == 3 && currentlist.listId != state.collectionID) {
          // console.log('list type 3 first load' )

          state.collectionFilters = [];
          state.activeFilters = 0;
          state.isFilterActive = false;

          if (filter_PriceFrom) {
            minprice = filter_PriceFrom;
            state.isFilterActive = true;
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_PriceFrom', val: minprice });
          }

          if (filter_PriceTo) {
            maxprice = filter_PriceTo;
            state.isFilterActive = true;
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_PriceTo', val: maxprice });
          }

          if (filter_PriceFrom || filter_PriceTo) {
            const priceRange = [filter_PriceFrom ? Math.round(filter_PriceFrom / 1000) : 1, filter_PriceTo ? Math.round(filter_PriceTo / 1000) : 47];
            Bus.$emit('setPriceFilters', priceRange, true);
          }

          if (filter_ArrivalDate && filter_Duration) {
            state.collectionFromDate = moment(filter_ArrivalDate).format('DD MMM YYYY');
            state.collectionToDate = moment(filter_ArrivalDate).add(filter_Duration, 'days').format('DD MMM YYYY');
            from = state.collectionFromDate;
            to = state.collectionToDate;
            state.isFilterActive = true;
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_ArrivalDate', val: from });
            Bus.$emit('setBookingDates', { start: from, end: to });
          }

          if (filter_RegionIds) {
            state.destinations = allRegions.filter((r) => filter_RegionIds.includes(r.id)).map((item) => ({ ...item, selected: true, open: false })).sort((a, b) => a.id - b.id);
            state.isFilterActive = true;
            Bus.$emit('selectRegions', state.destinations);
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_RegionIds', val: state.destinations });
          }

          if (filter_RegionIds && filter_SubRegionIds) {
            state.subDestinations = [...new Set(state.destinations.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id).filter((s) => filter_SubRegionIds.includes(s.id)))];
            state.isFilterActive = true;
            Bus.$emit('selectSubRegions', state.subDestinations);
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_SubRegionIds', val: state.subDestinations });
          }

          if (filter_People) {
            people = filter_People;
            state.isFilterActive = true;
            Bus.$emit('selectPeopleFilter', people, true);
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_People', val: people });
          }

          if (filter_BedsMin) {
            rooms = filter_BedsMin;
            state.isFilterActive = true;
            Bus.$emit('selectBedroomsFilter', rooms, true);
            state.activeFilters++;
            state.collectionFilters.push({ id: 'filter_BedsMin', val: rooms });
          }

          if (filter_Amenities) {
            amenities = filter_Amenities;
            // console.log('LIST TYPE 3 ON FIRST 1ST LOAD SET amenities TO:', amenities)
            // console.log('LIST TYPE 3 ON LOAD URL amenities =:', window.$router.app._route.query.amenities)
            const filtersFromCollection = filter_Amenities.split(',');
            // console.log('filtersFromCollection', filtersFromCollection)

            // let filtersFromURL =  !!window.$router.app._route.query.amenities ? window.$router.app._route.query.amenities.split(',') : [];
            // console.log('filtersFromURL', filtersFromURL)

            // let allfilters = [...filtersFromCollection, ...filtersFromURL];
            // let allfiltersSet = new Set(allfilters);
            // allfilters = [...allfiltersSet];

            // console.log('allfilters', allfilters)

            state.isFilterActive = true;
            // Bus.$emit('selectFilterByID', allfilters);

            if (window.$router.app._route.query.amenities !== amenities) {
              Bus.$emit('selectFilterByID', filtersFromCollection);
            }

            filtersFromCollection.forEach((x, i) => {
              state.activeFilters++;
              state.collectionFilters.push({ id: `filter_Amenities${i}`, val: x });
            });
          }

          state.listFilters = state.activeFilters;
        }

        // COLLECTION TYPE 3 - ON SUBSEQUENT LOADS
        if (listType == 3 && currentlist.listId == state.collectionID) {
          // console.log('COLLECTION TYPE 3 - ON SUBSEQUENT LOADS - ')

          if (filter_ArrivalDate && filter_Duration) {
            if (!!payload.query.from && payload.query.from === state.collectionFromDate && !!payload.query.to && payload.query.to === state.collectionToDate) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_ArrivalDate');
            }
          }

          if (filter_RegionIds) {
            const ids = state.destinations.map((x) => x.id);

            if (_.isEqual(ids, filter_RegionIds)) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_RegionIds');
            }
          }

          if (filter_RegionIds && filter_SubRegionIds) {
            const ids = state.subDestinations.map((x) => x.id);

            if (_.isEqual(ids, filter_SubRegionIds)) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_SubRegionIds');
            }
          }

          if (filter_People) {
            if (!!payload.query.people && payload.query.people == filter_People) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_People');
            }
          }

          if (filter_BedsMin) {
            if (!!payload.query.rooms && payload.query.rooms == filter_BedsMin) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_BedsMin');
            }
          }

          if (filter_PriceFrom) {
            if (!!payload.query.minprice && payload.query.minprice == Math.round(filter_PriceFrom / 1000) * 1000) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_PriceFrom');
            }
          }

          if (filter_PriceTo) {
            if (!!payload.query.maxprice && payload.query.maxprice == Math.round(filter_PriceTo / 1000) * 1000) {
              state.isFilterActive = true;
            } else {
              state.isFilterActive = false;
              state.collectionFilters = state.collectionFilters.filter((item) => item.id !== 'filter_PriceTo');
            }
          }

          if (filter_Amenities) {
            const filtersFromCollection = currentlist.filter_Amenities.split(',');

            if (payload.query.amenities) {
              // console.log('PAYLOAD AMENTIES = ', payload.query.amenities)

              let filtersFromURL = payload.query.amenities.split(',');
              const filtersFromURLSet = new Set(filtersFromURL);
              filtersFromURL = [...filtersFromURLSet];

              amenities = filtersFromURL;

              // window.$router.replace({ query: {...window.$router.app._route.query, amenities:'' } });
              // console.log('filtersFromCollection', filtersFromCollection);
              // console.log('filtersFromURL', filtersFromURL);
              // console.log('filtersFromURLSet', filtersFromURLSet);

              state.isFilterActive = filtersFromURL.includes(filtersFromCollection);

              // console.log('filters included?', filtersFromURL.includes(filtersFromCollection))

              const fe = filtersFromURL.find((el) => el == filtersFromCollection);

              filtersFromCollection.forEach((filter, i) => {
                const fil = filtersFromURL.find((f) => f == filter);
                if (fil) {
                  state.isFilterActive = true;
                } else {
                  state.collectionFilters = state.collectionFilters.filter((item) => item.id !== `filter_Amenities${i}`);
                }
              });
            }
            else {
              state.isFilterActive = false;
              filtersFromCollection.forEach((filter, i) => {
                state.collectionFilters = state.collectionFilters.filter((item) => item.id !== `filter_Amenities${i}`);
              });
            }
          }
        }

        if (state.activeFilters !== state.collectionFilters.length) {
          state.isFilterActive = false;
        }
      }/// /end if list type 3 main

      // set state collection id AFTER CHECKS to see if first render of collection or existing update
      state.collectionID = listid;

      amenities = !!amenities && amenities != '' ? amenities.toString() : null;
      // console.log('FINAL AMENITIES TO SEND TO API = ',amenities)

      // const regionExists = !!region && region != '';
      // const subregionExists = !!subregion && subregion != '';

      // convert dates to English locale before sending to server
      if (from) {
        const dtFrom = moment(from, 'DD MMM YYYY');
        dtFrom.locale('en');
        from = dtFrom.format('DD MMM YYYY');
      }

      if (to) {
        const dtTo = moment(to, 'DD MMM YYYY');
        dtTo.locale('en');
        to = dtTo.format('DD MMM YYYY');
      }

      const paramsToSend = {
        ...!!listid && { collectionid: listid },
        // ...!!regionExists && { region: region },
        // ...!!subregionExists && { subregion: subregion },
        ...!!from && { from },
        ...!!to && { to },
        ...!!rooms && { rooms },
        ...!!people && { people },
        ...!!amenities && { amenities },
        ...!!minprice && { minprice },
        ...!!maxprice && { maxprice },
      };

      // console.log('FINAL PARAMS TO SEND TO API = ', paramsToSend)
      // window.$router.replace({ query:paramsToSend });
      // window.$router.replace({ ...router.currentRoute,  query:paramsToSend });

      const res = await axios.get(`${apiEndpoint}/core/properties/search`, { params: paramsToSend });

      // if its a curated list, and its main filter is Not active,
      // and the URL is still equal to the collection url -
      // then reset back to main results layout and change url

      // console.log('----check listType', listType)
      // console.log('----check templateId', templateId)
      // console.log('----check state.isFilterActive', state.isFilterActive)
      // console.log('----check window.$router.app._route.path', window.$router.app._route.path)
      // console.log('----check hasHiddenPresetFilters', hasHiddenPresetFilters)

      if (listType == 3 && templateId == 5 && !state.isFilterActive && window.$router.app._route.path != resultsPagePath && !hasHiddenPresetFilters) {
        listid = null;
        listType = null;
        state.collectionID = 0;
        commit('pages/setCollectionData', null, { root: true });
        window.$router.replace({ path: resultsPagePath, query: { ...window.$router.app._route.query } });
        // console.log('reset results collections')
      }

      // console.log('---------results data response ==', res.data);
      // console.log(' res.data.amenityGroupCounts ',res.data.amenityGroupCounts)
      // console.log('currentlist after res', currentlist)
      // console.log('-------------------------------------')

      // of browser in Italy then only include villas where HideForItaly is FALSE
      let allProps = res.data.properties;
      if (['it', 'ita'].includes(rootGetters['common/getOfficeStatus'].countryCode)) {
        allProps = allProps.filter((p) => p.hideforitaly === false);
      } else if (['gr'].includes(rootGetters['common/getOfficeStatus'].countryCode)) {
        allProps = allProps.filter((p) => p.hideforgreece === false);
      }

      commit('setStatePayload', payload);
      commit('setOriginalProperties', allProps);
      // commit('setAvailablePropertiesAll', allProps);
      commit('setFilteredamenities', res.data.amenityGroupCounts);
      dispatch('filterPropertiesLocally');
    },

    // ---- Filter properties locally ----//
    filterPropertiesLocally({ commit, dispatch, state }) {
      const REGION_IDS = state.REGION_IDS;
      let allFP = state.originalProperties;
      const te = state.thinkExquisite;
      const destinations = state.destinations;
      const subDestinations = state.subDestinations;
      let fullRegions = [];
      let subRegions = [];

      let regionsResults = [];
      let subregionsResults = [];

      // Set the default sub region padding variable for each villa first
      allFP.forEach((p) => p.padding.subregion = 0);

      if (subDestinations.length > 0) {
        for (let i = 0; i < destinations.length; i++) {
          const des = destinations[i];
          const subs = des.subRegions.filter((d) => d.id != 999);
          const ids = subs.map((r) => Number(r.id));
          const included = subDestinations.filter((s) => ids.includes(s.id)).map((e) => Number(e.id));

          if (included.length === 0) {
            fullRegions.push(des.id);
          }
          else {
            subRegions = subRegions.length === 0 ? included : subRegions.concat(included);
          }
        }
      }
      else {
        fullRegions = state.destinations.map((d) => Number(d.id));
      }

      // filter properties - manipulate data to add padding
      if (fullRegions.length > 0) {
        regionsResults = allFP.filter((d) => fullRegions.includes(d.regionId)).map((region) => {
          region.padding.subregion = 0;
          return region;
        });
      }

      if (subRegions.length > 0) {
        const desIds = subDestinations.map((d) => d.regionId);

        subregionsResults = allFP.filter((d) => subRegions.includes(d.subRegionId)).map((sub) => {
          sub.padding.subregion = 0;
          return sub;
        });

        let alternativeSubregionsResults = allFP.filter((d) => !subRegions.includes(d.subRegionId) && desIds.includes(d.regionId)).map((sub) => {
          sub.padding.subregion = 1;
          return sub;
        });

        // Grouped subs in current results
        const groupedSubs = subregionsResults.filter((d) => d.searchLocationGroups.length > 0 && d.searchLocationGroups.includes('Minor_Italian_Islands_Sicily'));

        if (groupedSubs.length > 0) {
          // grouped subs not in above sections already
          const extraGroupedSubs = allFP.filter((d) => d.searchLocationGroups.length > 0 && d.searchLocationGroups.includes('Minor_Italian_Islands_Sicily') && !subregionsResults.includes(d) && !alternativeSubregionsResults.includes(d)).map((sub) => {
            sub.padding.subregion = 1;
            return sub;
          });

          if (extraGroupedSubs.length > 0) {
            alternativeSubregionsResults = [...new Set([...alternativeSubregionsResults, ...extraGroupedSubs])];
          }
        }

        subregionsResults = [...new Set([...subregionsResults, ...alternativeSubregionsResults])];

        allFP = regionsResults.length > 0 ? [...new Set([...regionsResults, ...subregionsResults])] : subregionsResults;
      }
      else if (fullRegions.length > 0 && subRegions.length === 0) {
        allFP = regionsResults;
      }

      if (te) {
        allFP = allFP.filter((p) => p.te === te);
      }

      commit('setAvailablePropertiesAll', allFP);
      dispatch('commitResults', state.statePayload);
    },

    commitResults({ commit, dispatch, state }) {
      const allFP = state.availablePropertiesAll;
      const availableProperties = allFP.filter((p) => p.booked === false);
      const bookedProperties = allFP.filter((p) => p.booked === true);
      const allProperties = [...availableProperties, ...bookedProperties];

      commit('setBookedProperties', bookedProperties);

      if ((state.showBooked)) {
        commit('setMapProperties', allProperties);
        commit('setAvailablePropertiesAll', allProperties);
        commit('setAvailableProperties', allProperties);
      } else {
        commit('setMapProperties', availableProperties);
        commit('setAvailablePropertiesAll', availableProperties);
        commit('setAvailableProperties', availableProperties);
      }

      dispatch('sortPropertiesBy', state.sortBy);
    },

    sortPropertiesBy({ commit, state }, sname) {
      let allFP = state.availablePropertiesAll;
      commit('setSortBy', sname);

      // If villa has reduced occupancy - use priced for data for beds and sleeps when sorting
      allFP.forEach((property) => {
        property.beds = property.pricedFor_Rooms || property.beds;
        property.sleeps = property.pricedFor_Sleeps || property.sleeps;
      });

      if (sname === 'location') {
        allFP = allFP.sort((a, b) => ((a.region > b.region) ? 1 : (a.region === b.region) ? ((a.loc > b.loc) ? 1 : (a.loc === b.loc) ? ((a.lat > b.lat) ? 1 : -1) : -1) : -1));
      }

      if (sname === 'alphabetically') {
        allFP = allFP.sort((a, b) => ((a.name > b.name) ? 1 : (a.name === b.name) ? ((a.region > b.region) ? 1 : -1) : -1));
      }

      if (sname === 'smallest') {
        allFP = allFP.sort((a, b) => ((a.beds > b.beds) ? 1 : (a.beds === b.beds) ? ((a.sleeps > b.sleeps) ? 1 : (a.sleeps === b.sleeps) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : -1) : -1) : -1));
      }

      if (sname === 'largest') {
        allFP = allFP.sort((b, a) => ((a.beds > b.beds) ? 1 : (a.beds === b.beds) ? ((a.sleeps > b.sleeps) ? 1 : (a.sleeps === b.sleeps) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? -1 : 1) : -1) : -1));
      }

      if (sname === 'pricelow') {
        allFP = allFP.sort((a, b) => {
          if (a.priceFrom === null || b.priceFrom === null) {
            // Move items with null priceFrom to the end of the list
            if (a.priceFrom === b.priceFrom) {
              return 0;
            } else if (a.priceFrom === null) {
              return 1;
            } else {
              return -1;
            }
          }

          // Sort by priceFrom, pricedFor_Sleeps, and beds
          if (a.priceFrom === b.priceFrom) {
            if (a.pricedFor_Sleeps === b.pricedFor_Sleeps) {
              if (a.beds === b.beds) {
                return 0;
              } else {
                return a.beds > b.beds ? 1 : -1;
              }
            } else {
              return a.pricedFor_Sleeps > b.pricedFor_Sleeps ? 1 : -1;
            }
          } else {
            return a.priceFrom > b.priceFrom ? 1 : -1;
          }
        });
      }

      if (sname === 'pricehigh') {
        allFP = allFP.sort((b, a) => ((a.priceTo > b.priceTo) ? 1 : (a.priceTo === b.priceTo) ? ((a.pricedFor_Sleeps > b.pricedFor_Sleeps) ? 1 : (a.pricedFor_Sleeps === b.pricedFor_Sleeps) ? ((a.beds > b.beds) ? 1 : -1) : -1) : -1));
      }

      if (sname === 'bedslow') {
        allFP = allFP.sort((a, b) => ((a.beds > b.beds) ? 1 : (a.beds === b.beds) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : -1) : -1));
      }

      if (sname === 'bedshigh') {
        allFP = allFP.sort((b, a) => ((a.beds > b.beds) ? 1 : (a.beds === b.beds) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? -1 : 1) : -1));
      }

      if (sname === 'sleepslow') {
        allFP = allFP.sort((a, b) => ((a.sleeps > b.sleeps) ? 1 : (a.sleeps === b.sleeps) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : -1) : -1));
      }

      if (sname === 'sleepshigh') {
        allFP = allFP.sort((b, a) => ((a.sleeps > b.sleeps) ? 1 : (a.sleeps === b.sleeps) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? -1 : 1) : -1));
      }

      if (sname === 'default') {
        if (state.selectedBedrooms > 0) {
          allFP = allFP.sort((a, b) => ((a.beds > b.beds) ? 1 : (a.beds === b.beds) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : -1) : -1));
        } else if (state.selectedPeople > 0) {
          allFP = allFP.sort((a, b) => ((a.sleeps > b.sleeps) ? 1 : (a.sleeps === b.sleeps) ? ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : -1) : -1));
        } else {
          allFP = allFP.sort((a, b) => ((a.sortOrder_Recommended > b.sortOrder_Recommended) ? 1 : (a.sortOrder_Recommended === b.sortOrder_Recommended) ? ((a.name > b.name) ? 1 : -1) : -1));
        }
      }

      const availableProperties = allFP.filter((p) => p.booked === false);
      const bookedProperties = allFP.filter((p) => p.booked === true);
      const allProperties = [...availableProperties, ...bookedProperties];

      commit('setAvailablePropertiesAll', allProperties);
      commit('setAvailableProperties', allProperties);
      commit('setBookedProperties', bookedProperties);
    },

    resetResults({ commit, state }) {
      const allFP = state.availablePropertiesAll;

      const availableProperties = allFP.filter((p) => p.booked === false);
      const bookedProperties = allFP.filter((p) => p.booked === true);
      const allProperties = [...availableProperties, ...bookedProperties];
      commit('setBookedProperties', bookedProperties);
      commit('setAvailableProperties', allProperties);
      commit('setAvailablePropertiesAll', allProperties);
    },

    fetchMaxAllowableBeds({ commit }) {
      axios.get('/core/properties/maxroomsandsleeps')
        .then((res) => {
          const { bedroomsMax } = res.data;
          commit('setMaxAllowableBeds', bedroomsMax);
        })
        .catch((err) => {
          console.log('Error fetching max allowable beds:', err);
        });
    },
  },
};
